import { QUOTE_FIELDS } from './common';

import { hhmmss } from '../../../util/date-time';

import { hasProperty } from '../../../util/jquery';

export function marketsPullStatisticsTransform(data, params) {
    const dataList = data.status.errorCode === '0' ? data.data.dataList : [];
    return dataList.map(d => {
        return {
            instrument: d.statSymbol,
            quotes: convertStatTops(
                d.statAndTops,
                getStatFieldList(params.fields)
            )
        };
    });
}

function getStatFieldList(fields) {
    return fields.split(',').map(f => {
        return f.split(':')[0];
    });
}

function formatFieldValue(field, value) {
    if (/.*Time/i.test(QUOTE_FIELDS[field])) {
        if (/\d+:\d+:\d+/.test(value)) {
            value = value.split('.')[0];
        } else {
            value = hhmmss(value);
        }
    } else if (/.*Date/i.test(QUOTE_FIELDS[field])) {
        value = value.replace(/(\d+)(-|\.)(\d+)(-|\.)(\d+)/, '$5$3$1');
    }
    return value;
}

function convertStatTops(statTops, statFields) {
    const ret = [];
    statFields.forEach(statField => {
        const value = [];
        statTops[statField].forEach(quote => {
            const quotes = [
                {
                    name: 'realtimeDelay',
                    value: quote.dataType
                },
                {
                    name: 'symbol',
                    value: quote.symbol
                }
            ];
            for (const field in quote.fields) {
                if (hasProperty(QUOTE_FIELDS, field)) {
                    quotes.push({
                        name: QUOTE_FIELDS[field],
                        value: formatFieldValue(field, quote.fields[field])
                    });
                } else if (field === 'H8') {
                    quotes.push({
                        name: 'chg',
                        value: quote.fields[field]
                    });
                } else if (field === 'NetChange') {
                    quotes.push({
                        name: 'chg%',
                        value: quote.fields[field].replace(/%$/, '')
                    });
                } else if (field === 'Currency') {
                    quotes.push({
                        name: 'listedCurrency',
                        value: quote.fields[field]
                    });
                }
            }
            value.push({
                instrument: quote.ticker,
                quotes: quotes
            });
        });
        ret.push({
            name: statField,
            value: value
        });
    });
    return ret;
}
